import type { FaireProductEntity } from "../../entity_types/product";

export const p_xqys3qg3gf: FaireProductEntity = {
  token: "p_xqys3qg3gf",
  type: "product",
  name: "LACE TRIM BIAS CUT MIDI SKIRT",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/43c3dd82bc961417b639060c7c823d03979f15b343777d43d26a8dcc4d4e217f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/18b733aaa2df9c9c7959e06b9203b2eb5f405a03bbae91faf9790393889add60.jpeg",
    "https://cdn.faire.com/fastly/8271856b2e18b96f9dccd12f8565c2dbaec53ded02ef9b09563bcd41a5ca1228.jpeg",
    "https://cdn.faire.com/fastly/0080852814ea2719e3be5668e73cc61fbb083457e9329b820dabc8347af63127.jpeg",
    "https://cdn.faire.com/fastly/13c77c7c4b8441177237ef6cf840d4989d814cb8ec784cc75ecffc134ac6072e.jpeg",
    "https://cdn.faire.com/fastly/3d1fe00ceec56e56b3e60abb2082df7155c4026cbd9b8427b6ba02cf4af8967c.jpeg",
    "https://cdn.faire.com/fastly/c6c971a03e0750c4f39afc5d8333c4e3b59a5407aad6bf9ac11eaca8409c0aa6.jpeg",
    "https://cdn.faire.com/fastly/27d80567f470619f800d206ee45ff590c74ff725b92024e114fb79d2e2c44613.jpeg",
    "https://cdn.faire.com/fastly/aaec8fa072fd030efe4c8c6d79fefd1f6765586f539aeaff4ba0604ead1f8b3b.jpeg",
    "https://cdn.faire.com/fastly/32638d5949c2904ad61031f2af01d5ea27949969a4a125d0ab600bea013ccc0c.jpeg",
    "https://cdn.faire.com/fastly/bc8936ac58cbba1122948d708a52b51cc65def15b3c15d755835da34df852c35.jpeg",
    "https://cdn.faire.com/fastly/7fbabdee4e775bb5b5d36f75ed4aaedbd96e8d5a61ce58735bae28722c3e8dff.jpeg",
    "https://cdn.faire.com/fastly/ad76b3e6a2f71198926b8cad8e137bb685cd23b1dc5051f773fa04edd1ddbaf3.jpeg",
    "https://cdn.faire.com/fastly/70a86084e3cc131f9ecc6637547c470dff6b25c3513de493bdd9c7ceba532eab.jpeg",
    "https://cdn.faire.com/fastly/8e9471f43ef1007e5076c5e228dc6a8ea567fda3959f876bebaafbe6ec2f758d.jpeg",
    "https://cdn.faire.com/fastly/60d8b37c8eab0ef7fa638070078d71b2f1c688f5bb58b7940c1114be210cf108.jpeg",
    "https://cdn.faire.com/fastly/925de17d21b45e00f751413dc8a2351f97f77b5cb149ca8ddc00af3613f2c2a0.jpeg",
    "https://cdn.faire.com/fastly/f1839b852a0dcfbf940ace2e77cbaa977f8d3e36e38d576096033325211bfefb.jpeg",
    "https://cdn.faire.com/fastly/27afb050281553ac7505336369fd605ee861fdcb3a222303dd27fdf12ee23021.jpeg",
    "https://cdn.faire.com/fastly/9005441c7bc5999fd2d8bde01fa5f156278535b3a56702b9973adde4b44b6019.jpeg",
    "https://cdn.faire.com/fastly/11ae346ecae6970fa227b8228a5c020ad840283423081c3c060a3fbedc8bfd31.jpeg",
    "https://cdn.faire.com/fastly/8627ef85ba8ca754e321e57559ed115f51b83c990d3c168a23d1e0f04648844a.jpeg",
    "https://cdn.faire.com/fastly/1d25dfd43593a3dfba692030c2dd96c57fcc8fb5cc2a07784727fd8061e440ff.jpeg",
    "https://cdn.faire.com/fastly/b2e6ec05b7e2f0a953897d7546f74b6a2719194d2aa56d3606d2d3f8365f3e32.jpeg",
    "https://cdn.faire.com/fastly/dbf8cf1e5bc4b0c17b36ea2d34339fd20a412fb69c985ac8ea73339bc89d9328.jpeg",
    "https://cdn.faire.com/fastly/8af1ae9d23248e3fcdaab1eabfe10bc8479c2d0c1f06b7234b7aae03849ed9a4.jpeg",
    "https://cdn.faire.com/fastly/a86221db9c598368299adaba2e0c2d8c3e2a74d2cd399915d88313412743c181.jpeg",
    "https://cdn.faire.com/fastly/a2cd9539cc620bea465c791fb3faa4093222a017a4ac4dae8b5a07c2c61e0e7f.jpeg",
    "https://cdn.faire.com/fastly/9371c4a537df7dafe31fa887b425b5ae39e0102c22c12ecbd433816c5ee726a9.jpeg",
    "https://cdn.faire.com/fastly/fa0674b9e6f8b472f61851edfda989dc1abe48b7cd9655cd0948c602b1d3ecaf.jpeg",
    "https://cdn.faire.com/fastly/8e5ebe0738603a7d4b3c71e5a975b3f3cb70876af4056e4c96d89f049f6598f8.jpeg",
    "https://cdn.faire.com/fastly/945118b40910b08f22e8a3a4e1522291394dee23204a63e902307cc730d92fa4.jpeg",
    "https://cdn.faire.com/fastly/b7092de8bc8925b8cc52f0be6ad5992d7ed15a0ee78094f970fbd232ec4ef8f3.jpeg",
    "https://cdn.faire.com/fastly/79815bfda2dc1aeb19edf4b4a0a50a2e1c6526bcd54ef5d4da615d481216a0fc.jpeg",
    "https://cdn.faire.com/fastly/abdc1e8d70332a6734a990c030b1002b417d626b04c9ccf767dc65cdf6d24ae4.jpeg",
    "https://cdn.faire.com/fastly/cfc95f13483bcf98f6e141596aea26b36c2369779b9cb3c9af059fd04f592e7c.jpeg",
    "https://cdn.faire.com/fastly/db234bb1cec9c9b02c09ef880b43cb9a9e87892c03cf541b80a9af969c2b4b7a.jpeg",
    "https://cdn.faire.com/fastly/66cdd6f6f53cb81082b21051a40d3227c7d26ef80ca102df9f831fb5de989737.jpeg",
    "https://cdn.faire.com/fastly/48e2055c206d4fb1f2d4cc11fd6264c102e767731cbc716afc9c8dc9bad58872.jpeg",
    "https://cdn.faire.com/fastly/2b8e6ca3b6c45da5b360b2d2f6bcca3a2dd9472a28b1513d9611b9cd12f6b0b8.jpeg",
    "https://cdn.faire.com/fastly/d873d2e7aa9161115a0a16db2643dff0bb951a9dd044117a195f5904455a9fec.jpeg",
    "https://cdn.faire.com/fastly/e51157985ca50736706f59bc1d5b34fbc6a6f56248b4cfe29db0447c7e1e69dc.jpeg",
    "https://cdn.faire.com/fastly/2ce0277d9a19ae8c1fbc81dbe02c537f7c8ee9ff83fc95b2ac1d89d07277b809.jpeg",
    "https://cdn.faire.com/fastly/a15613e631f7d4d2c3843e04c11c1f67ff923428ee5a2d21f58322f457c807c8.jpeg",
    "https://cdn.faire.com/fastly/8e66fabf948d1fe67a419d5c1459604275f9d5b54aa3dddc794d3922af9d9a52.jpeg",
    "https://cdn.faire.com/fastly/8272aec0d5ee8960e8b3f88c39bdc679d51027eafdd9df2567223eead22cecd9.jpeg",
    "https://cdn.faire.com/fastly/0401a234fd967aae2ac59b1e96b6811dc82474ff81acb36f88dcdbd3fb6da5f6.jpeg",
    "https://cdn.faire.com/fastly/ee2b302648d078a18cec832dd0fa583858d6b001b2224c6959f6af51d418c59c.jpeg",
  ],
  priceDollars: 174,
  description:
    'Model is wearing a size small\n\n𝐌𝐨𝐝𝐞𝐥 𝐬𝐩𝐞𝐜𝐬\nHeight: 5\'8"\nBust: 32B\nWaist: 24"\nHips: 34"',
  tags: [],
  msrpDollars: 348,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:16.945Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
